import { render, staticRenderFns } from "./WalletTansactionsHistoryTable.vue?vue&type=template&id=6d9e58a6"
import script from "./WalletTansactionsHistoryTable.vue?vue&type=script&lang=js"
export * from "./WalletTansactionsHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports